import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();


const RECAPTCHA_SITE_KEY = '6LeZf4EtAAAAAIpq9_XGhOfNgfNQ7KUWXx9dS0FV';

ReactDOM.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={RECAPTCHA_SITE_KEY}
    scriptProps={{
      async: true,
      defer: true,
    }}
  >
    <App />
  </GoogleReCaptchaProvider>,
  document.getElementById('root')
);

